function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 139.915,
  cy: 139.925,
  r: 99.9295,
  fill: "#E8EAEC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M139.555 213.894L181.076 109.716C182.813 105.357 187.755 103.231 192.115 104.969C196.474 106.706 198.599 111.648 196.862 116.008L157.209 215.498L139.555 213.894Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M155.922 123.233C155.926 123.223 155.93 123.213 155.935 123.203C155.93 123.203 155.926 123.204 155.922 123.205L155.922 123.233Z",
  fill: "#FFF9C5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M192.115 104.969C187.756 103.231 182.814 105.357 181.077 109.716L170.204 136.996C172.974 137.438 175.73 138.194 178.442 139.276C181.155 140.357 183.685 141.703 185.994 143.278L196.863 116.008C198.6 111.648 196.474 106.706 192.115 104.969Z",
  fill: "#C7CDD3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M207.151 67.2466L175.821 70.614L155.922 93.7891L155.925 123.198L155.939 123.192C155.938 123.196 155.936 123.199 155.935 123.203C164.625 121.589 174.3 122.435 183.666 126.168C192.972 129.877 200.537 135.866 205.733 142.955L205.824 143.121L222.191 126.915L224.017 86.4775L207.151 67.2466Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M155.925 123.198C150.727 116.051 143.121 110.009 133.756 106.277C124.386 102.542 114.705 101.696 106.013 103.313C106.013 103.313 148.192 43.7482 207.151 67.2469C207.151 67.2469 176.232 75.5169 155.922 123.233L155.925 123.198Z",
  fill: "#969FA8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M205.845 143.094C214.535 141.482 224.211 142.328 233.576 146.061C242.946 149.796 250.555 155.841 255.752 162.993C255.752 162.993 266.109 90.7453 207.15 67.2461C207.15 67.2461 223.904 94.5165 205.824 143.121L205.845 143.094Z",
  fill: "#969FA8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M236.396 232.519C224.995 214.294 186.38 200.882 140.499 200.882C94.6185 200.882 56.0053 214.293 44.6025 232.517L51.0082 232.519L64.9095 241.434L79.5265 243.023L89.828 237.071L106.18 231.107L114.954 233.49L133.622 243.023L145.935 241.037L161.823 235.109L173.341 231.504L188.037 235.109L199.952 243.023L219.018 240.64L236.396 232.519Z",
  fill: "#C7CDD3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M220.356 240.014L236.397 232.519C224.996 214.294 186.381 200.882 140.5 200.882C129.95 200.882 119.787 201.593 110.25 202.906C157.58 208.334 197.166 221.946 220.356 240.014Z",
  fill: "#4F5357"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M258.452 234.475C247.185 226.834 232.624 226.834 221.357 234.475C212.496 240.485 201.044 240.485 192.182 234.475C180.915 226.834 166.354 226.834 155.087 234.475C146.226 240.485 134.774 240.485 125.912 234.475C114.645 226.834 100.084 226.834 88.817 234.475C79.955 240.485 68.5036 240.485 59.6415 234.475C48.3746 226.834 33.8138 226.834 22.5469 234.475C20.9346 235.569 20.514 237.762 21.6073 239.375C22.7006 240.987 24.8947 241.407 26.5065 240.314C35.368 234.304 46.82 234.304 55.682 240.314C66.9493 247.955 81.5102 247.955 92.7766 240.314C101.638 234.304 113.09 234.304 121.952 240.314C133.219 247.955 147.78 247.955 159.047 240.314C167.908 234.304 179.36 234.304 188.222 240.314C193.856 244.135 200.313 246.045 206.77 246.045C213.226 246.045 219.684 244.135 225.317 240.314C234.178 234.304 245.63 234.304 254.492 240.314C256.105 241.408 258.298 240.987 259.391 239.375C260.485 237.763 260.064 235.569 258.452 234.475Z",
  fill: "#969FA8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1412 93.3604C70.7544 93.3604 79.3581 84.7567 79.3581 74.1435C79.3581 63.5303 70.7544 54.9266 60.1412 54.9266C49.528 54.9266 40.9243 63.5303 40.9243 74.1435C40.9243 84.7567 49.528 93.3604 60.1412 93.3604Z",
  fill: "#C7CDD3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1415 48.15C58.1933 48.15 56.6143 46.5705 56.6143 44.6228V37.5272C56.6143 35.579 58.1938 34 60.1415 34C62.0891 34 63.6687 35.5795 63.6687 37.5272V44.6228C63.6687 46.571 62.0891 48.15 60.1415 48.15Z",
  fill: "#C7CDD3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M81.0139 56.7961C80.1113 56.7961 79.2086 56.4518 78.52 55.7628C77.1424 54.3851 77.1424 52.1517 78.52 50.7741L83.5373 45.7568C84.9149 44.3792 87.1483 44.3792 88.5255 45.7568C89.9031 47.1345 89.9031 49.3679 88.5255 50.7455L83.5082 55.7628C82.8192 56.4518 81.9165 56.7961 81.0139 56.7961Z",
  fill: "#C7CDD3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M96.7552 77.6688H89.66C87.7119 77.6688 86.1328 76.0893 86.1328 74.1416C86.1328 72.1939 87.7123 70.6144 89.66 70.6144H96.7552C98.7033 70.6144 100.282 72.1939 100.282 74.1416C100.282 76.0893 98.7033 77.6688 96.7552 77.6688Z",
  fill: "#C7CDD3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0311 103.559C85.1285 103.559 84.2254 103.215 83.5373 102.526L78.52 97.5083C77.1424 96.1307 77.1424 93.8973 78.52 92.5197C79.8977 91.142 82.1311 91.142 83.5082 92.5197L88.5255 97.5369C89.9031 98.9145 89.9031 101.148 88.5255 102.526C87.8364 103.214 86.9343 103.559 86.0311 103.559Z",
  fill: "#C7CDD3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1415 114.282C58.1933 114.282 56.6143 112.703 56.6143 110.755V103.66C56.6143 101.711 58.1938 100.132 60.1415 100.132C62.0891 100.132 63.6687 101.712 63.6687 103.66V110.755C63.6687 112.704 62.0891 114.282 60.1415 114.282Z",
  fill: "#C7CDD3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2512 103.559C33.3486 103.559 32.4459 103.215 31.7573 102.526C30.3797 101.148 30.3797 98.9145 31.7573 97.5369L36.7741 92.5197C38.1517 91.142 40.3852 91.142 41.7623 92.5197C43.1399 93.8973 43.1399 96.1307 41.7623 97.5083L36.7455 102.526C36.057 103.214 35.1543 103.559 34.2512 103.559Z",
  fill: "#C7CDD3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6228 77.6688H23.5272C21.579 77.6688 20 76.0893 20 74.1416C20 72.1939 21.5795 70.6144 23.5272 70.6144H30.6228C32.571 70.6144 34.15 72.1939 34.15 74.1416C34.15 76.0893 32.571 77.6688 30.6228 77.6688Z",
  fill: "#C7CDD3"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2684 56.7961C38.3658 56.7961 37.4632 56.4518 36.7746 55.7628L31.7573 50.746C30.3797 49.3684 30.3797 47.135 31.7573 45.7573C33.135 44.3797 35.3684 44.3797 36.7455 45.7573L41.7623 50.7746C43.1399 52.1522 43.1399 54.3856 41.7623 55.7632C41.0742 56.4518 40.1711 56.7961 39.2684 56.7961Z",
  fill: "#C7CDD3"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 143,
  r: 6,
  stroke: "#969FA8",
  strokeWidth: 4
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 188,
  r: 4,
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 188,
  r: 4,
  stroke: "#717A82"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 53,
  r: 4,
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 53,
  r: 4,
  stroke: "#717A82"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 159,
  r: 4,
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 159,
  r: 4,
  stroke: "#E8EAEC"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 32,
  r: 6,
  stroke: "#969FA8",
  strokeWidth: 4
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90 144C89.1716 144 88.5 144.672 88.5 145.5V148.5H85.5C84.6716 148.5 84 149.172 84 150C84 150.828 84.6716 151.5 85.5 151.5H88.5V154.5C88.5 155.328 89.1716 156 90 156C90.8284 156 91.5 155.328 91.5 154.5V151.5H94.5C95.3284 151.5 96 150.828 96 150C96 149.172 95.3284 148.5 94.5 148.5H91.5V145.5C91.5 144.672 90.8284 144 90 144Z",
  fill: "#969FA8"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46 201C45.1716 201 44.5 201.672 44.5 202.5V205.5H41.5C40.6716 205.5 40 206.172 40 207C40 207.828 40.6716 208.5 41.5 208.5H44.5V211.5C44.5 212.328 45.1716 213 46 213C46.8284 213 47.5 212.328 47.5 211.5V208.5H50.5C51.3284 208.5 52 207.828 52 207C52 206.172 51.3284 205.5 50.5 205.5H47.5V202.5C47.5 201.672 46.8284 201 46 201Z",
  fill: "#C7CDD3"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246 97C245.172 97 244.5 97.6716 244.5 98.5V101.5H241.5C240.672 101.5 240 102.172 240 103C240 103.828 240.672 104.5 241.5 104.5H244.5V107.5C244.5 108.328 245.172 109 246 109C246.828 109 247.5 108.328 247.5 107.5V104.5H250.5C251.328 104.5 252 103.828 252 103C252 102.172 251.328 101.5 250.5 101.5H247.5V98.5C247.5 97.6716 246.828 97 246 97Z",
  fill: "#717A82"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M224 188C223.172 188 222.5 188.672 222.5 189.5V192.5H219.5C218.672 192.5 218 193.172 218 194C218 194.828 218.672 195.5 219.5 195.5H222.5V198.5C222.5 199.328 223.172 200 224 200C224.828 200 225.5 199.328 225.5 198.5V195.5H228.5C229.328 195.5 230 194.828 230 194C230 193.172 229.328 192.5 228.5 192.5H225.5V189.5C225.5 188.672 224.828 188 224 188Z",
  fill: "#969FA8"
});

var SvgVacationsHistoryEmptyStateLight = function SvgVacationsHistoryEmptyStateLight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVacationsHistoryEmptyStateLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/vacationsHistoryEmptyStateLight.f2393d87.svg";
export { ForwardRef as ReactComponent };